// components/DemoContent.tsx
import React, { useEffect, useState } from "react";
import type { PagesStore, PageStore } from "./components";
import apis from "../utils/apis";
import useRequest from "../utils/use-request";
import { Spin } from "@gw/web-basic-components";

interface DemoContentProps {
  store: PagesStore;
  updateStore: (data: PageStore, key: string) => void;
  cardKey: string;
  permissionId: string;
  isDemo: boolean;
}

const DemoContent: React.FC<DemoContentProps> = ({
  store,
  updateStore,
  cardKey,
  permissionId,
  isDemo,
}) => {
  const [isIframeLoading, setIsIframeLoading] = useState(true);
  const [, fetchDemoConfig] = useRequest<{ permissionId: string }, any>(
    apis.token.demo
  );
  const getDemoConfig = async () => {
    try {
      const res = await fetchDemoConfig({ permissionId });
      const url = res.toLowerCase();
      const imageExtensions = [
        ".jpg",
        ".jpeg",
        ".png",
        ".gif",
        ".webp",
        ".svg",
      ];
      const isImage = imageExtensions.some((ext) => url.endsWith(ext));
      if (isImage) {
        updateStore(
          {
            specialContent: {
              imageUrl: res,
            },
          },
          cardKey
        );
      } else if (url.endsWith(".html") || url.endsWith(".htm")) {
        const htmlContent = await fetch(res).then((response) =>
          response.text()
        );
        updateStore(
          {
            specialContent: {
              html: htmlContent,
            },
          },
          cardKey
        );
      } else {
        updateStore(
          {
            specialContent: {
              webUrl: res,
            },
          },
          cardKey
        );
      }
    } catch (error) {
      updateStore({}, cardKey);
    }
  };

  useEffect(() => {
    if (!isDemo || store?.[cardKey]?.specialContent) return;
    getDemoConfig();
  }, [cardKey]);

  useEffect(() => {
    if (store?.[cardKey]?.specialContent?.webUrl) {
      setIsIframeLoading(true);
    }
  }, [store?.[cardKey]?.specialContent?.webUrl]);

  return (
    <>
      {store?.[cardKey]?.specialContent?.imageUrl && (
        <img
          style={{
            objectFit: "contain",
            objectPosition: "top",
            width: "100%",
            height: "auto",
          }}
          src={store[cardKey].specialContent.imageUrl}
          alt="示例"
        />
      )}
      {store?.[cardKey]?.specialContent?.html && (
        <iframe
          srcDoc={store[cardKey].specialContent.html}
          title="示例"
          style={{
            width: "100%",
            height: "100%",
            border: "none",
          }}
        />
      )}
      {store?.[cardKey]?.specialContent?.webUrl && (
        <div style={{ position: "relative", width: "100%", height: "100%" }}>
          <Spin
            style={{ position: "absolute", top: "50%", left: "50%" }}
            spinning={isIframeLoading}
            size="large"
          />
          <iframe
            src={store[cardKey].specialContent.webUrl}
            title="示例"
            sandbox="allow-same-origin allow-scripts allow-forms allow-popups allow-popups-to-escape-sandbox"
            style={{
              width: "100%",
              maxWidth: "100%",
              height: "100%",
              border: "none",
              overflowX: "hidden",
              opacity: isIframeLoading ? 0.3 : 1,
              transition: "opacity 0.3s ease",
            }}
            onLoad={() => setIsIframeLoading(false)}
          />
        </div>
      )}
    </>
  );
};

export default DemoContent;
